import { render, staticRenderFns } from "./campaign-temp-item.vue?vue&type=template&id=cbc6d4e4&scoped=true&"
import script from "./campaign-temp-item.vue?vue&type=script&lang=ts&"
export * from "./campaign-temp-item.vue?vue&type=script&lang=ts&"
import style0 from "./campaign-temp-item.vue?vue&type=style&index=0&id=cbc6d4e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc6d4e4",
  null
  
)

export default component.exports